import { FETCH_LMS_TRAINING_DATA } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_LMS_TRAINING_DATA);
export default addReducer;
